module.exports = __webpack_public_path__ + "static/media/nerd.5085bc1e.png";